// extracted by mini-css-extract-plugin
module.exports = {"styledModal":"ZGWFtyq3"};